export class TableData {
  date: Date;
  label: string;
  tooltipText: string;
}
